import { t } from "i18next";
import PdfIcon from "@assets/icons/pdf.svg";
import WebIcon from "@assets/icons/earth.svg";
import YoutubeIcon from "@assets/icons/youtube.svg";

export enum ROLES {
  USER = "user",
  ASSISTANT = "assistent",
}

export enum ERROR_TYPES {
  INVALID = "invalid",
  NETWORK_ERROR = "networkError",
  NO_INTERNET = "noInternet",
  CUSTOM = "custom",
  DEFAULT = "default",
}

export enum INPUT_TYPES {
  FORM = "@from",
}

export enum CHAT_RESPONSE_STREAM_TIME {
  REFETCH_INTERVAL = 300,
  FIRST_REFETCH_WAIT = 3,
}

export const VALIDATION_STATES = {
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  NONE: "none",
};

export const enum QUERY_TYPE {
  PDF = "pdf",
  WEBSITE = "website",
  YOUTUBE = "youtube",
  DEEP_SEARCH = "deepsearch",
}

export const chatHeaderData = () => [
  {
    title: t("common:chat.addPdfLink"),
    icon: PdfIcon,
    value: QUERY_TYPE.PDF,
  },
  {
    title: t("common:chat.addWebLink"),
    icon: WebIcon,
    value: QUERY_TYPE.WEBSITE,
  },
  {
    title: t("common:chat.addYoutubeLink"),
    icon: YoutubeIcon,
    value: QUERY_TYPE.YOUTUBE,
  },
];
